module.exports = __webpack_public_path__ + "static/11-63819342154e30a0a8d548e6c30b60d4.svg";